import { memo } from "react";
import { AiEmailSuggestions } from "./ai-email-suggestions";

interface AiSubjectLineSuggestionsProps {
  subject: string;
  onSuggestionClick: (suggestion: string) => void;
  getAiSubjectLineSuggestions: (
    params: { text: string; tone?: string },
    options?: { signal?: AbortSignal },
  ) => Promise<{ text: string; tone: string }[]>;
}

export const AiSubjectLineSuggestions = memo(function AiSubjectLineSuggestions(
  props: AiSubjectLineSuggestionsProps,
) {
  const { subject, onSuggestionClick, getAiSubjectLineSuggestions } = props;

  return (
    <AiEmailSuggestions
      fetchSuggestions={getAiSubjectLineSuggestions}
      logLabel="AI Suggestions"
      onSuggestionClick={onSuggestionClick}
      text={subject}
      title="Subject line suggestions"
    />
  );
});
